import apiClient from '../../lib/util/api-client'
import { crudActions } from '../factories'

const uuidService = apiClient.service('library-providers/request-uuid')

export const { find, setList, clearList, get } = crudActions({ name: 'libraryProviders' })

export const createRequestUUID = async ({ props }) => {
  const { providerSlug, paramsKey } = props
  const result = await uuidService.create({ providerSlug, paramsKey })
  const { uuid } = result || {}
  return { uuid }
}
